import {JobStatus, JobType} from "./enums";


// Function to convert the date string to a Date object
export function addParsedDateToJob(job: JobRead): JobRead {
    const job_created_date = job.date_created ? new Date(job.date_created) : undefined;
    const job_completed_date = job.date_completed ? new Date(job.date_completed) : undefined;
    return {
        ...job,
        date_created_parsed: job_created_date,
        date_completed_parsed: job_completed_date,
    };
}

export interface JobWarning {
    file_name: string;
    error_type: 'unsupported_file' | 'processing_error';
    message: string;
    doc_id?: string;
    folder_id?: string;
}

export interface JobRead {
    id: number;
    progress: number;
    type: JobType;

    date_created?: string;
    date_created_parsed?: Date;

    date_completed?: string;
    date_completed_parsed?: Date;

    status: JobStatus;
    updating_ids: string[];
    updated_ids: string[];
    warnings?: JobWarning[];
    folder_ids: string[];
    group_id: string;
    submitter_id?: string;
}

// Type definition for a collection of Document objects.
export type JobResults = {
    jobs: JobRead[];
}

export interface  QueueUploadFilesResponse{
    job: JobRead;
    session_upload_urls: string[];
}

export const JobStatusToLabelMap: { [key in JobStatus]: string } = {
    [JobStatus.UNASSIGNED]: "Unassigned",
    [JobStatus.QUEUED]: "Queued",
    [JobStatus.PROCESSING]: "Processing",
    [JobStatus.COMPLETED]: "Finished Processing",
    [JobStatus.FAILED]: "Failed",
};

export const JobTypeToLabelMap: { [key in JobType]: string } = {
    [JobType.UPLOAD]: "Uploading Files",
    [JobType.TAG_UPDATE]: "Processing Tags",
    [JobType.PRODUCTION]: "Producing Data",
    [JobType.INVESTIGATION]: "Investigating Data",
    [JobType.SEED]: "Setting Up Demo Workspace",
};


export function getJobStatusLabel(job: JobRead, defaultLabel: string = ""): string {
    const status = job.status;
    if (!status) return defaultLabel;
    const prefix = JobStatusToLabelMap[status] ?? defaultLabel;
    const suffix = JobTypeToLabelMap[job.type] ?? "";
    if (suffix) {
        return `${prefix} - ${suffix}`;
    }
    return prefix;
}
